import { callFunctionRaw, resolveFunctionAccessToken } from "@/lib/callFunction.js";

function traceProfessionalConnectionEmailDispatch(event, detail = {}) {
  if (!import.meta.env.DEV) return;
  console.info("[ProfessionalConnectionEmailDispatch]", { event, ...detail });
}

async function requireAccessToken() {
  const accessToken = await resolveFunctionAccessToken({
    refreshIfMissing: false,
    forceRefresh: false,
  });
  if (!String(accessToken || "").trim()) {
    throw new Error("Session expired. Please sign in again.");
  }
  return accessToken;
}

export async function sendPaymentRequestEmail(payload = {}) {
  const accessToken = await requireAccessToken();
  return callFunctionRaw("send-payment-request", payload, {
    accessToken,
    timeoutMs: 10000,
    preferFreshSession: false,
  });
}

export async function sendReferralUpdateEmail(payload = {}) {
  const accessToken = await requireAccessToken();
  return callFunctionRaw("send-referral-update", payload, {
    accessToken,
    timeoutMs: 10000,
    preferFreshSession: false,
  });
}

export async function sendProfessionalConnectionEmail(payload = {}) {
  const connectionId = String(payload?.connection_id || "").trim();
  const eventType = String(payload?.event_type || "").trim();
  traceProfessionalConnectionEmailDispatch("fresh_session_requested", { connectionId, eventType });
  const accessToken = await resolveFunctionAccessToken({
    refreshIfMissing: true,
    forceRefresh: true,
  });
  traceProfessionalConnectionEmailDispatch("fresh_session_resolved", {
    connectionId,
    eventType,
    hasAccessToken: Boolean(String(accessToken || "").trim()),
  });
  if (!String(accessToken || "").trim()) {
    throw new Error("Session expired. Please sign in again.");
  }
  let result;
  try {
    traceProfessionalConnectionEmailDispatch("edge_invoke_started", { connectionId, eventType });
    result = await callFunctionRaw("send-professional-connection-email", payload, {
      accessToken,
      timeoutMs: 10000,
      preferFreshSession: true,
    });
  } catch (error) {
    traceProfessionalConnectionEmailDispatch("edge_invoke_failed", {
      connectionId,
      eventType,
      errorCode: String(error?.code || "").trim(),
      httpStatus: Number(error?.status || 0) || null,
    });
    throw error;
  }
  traceProfessionalConnectionEmailDispatch("edge_invoke_completed", {
    connectionId,
    eventType,
    ok: result?.ok === true,
    status: String(result?.status || "").trim(),
    errorCode: String(result?.error || "").trim(),
    dispatchId: String(result?.dispatch_id || "").trim(),
    provider: String(result?.provider || "").trim(),
    messageId: String(result?.message_id || "").trim(),
    reason: String(result?.reason || "").trim(),
    retryable: result?.retryable === true,
    idempotent: result?.idempotent === true,
  });
  if (!result?.ok) {
    const error = new Error(String(result?.error || "email_dispatch_failed"));
    error.code = String(result?.error || "email_dispatch_failed");
    throw error;
  }
  return result;
}
